<script lang="ts">
import type { CollapsibleEmits, CollapsibleProps } from '#ui/types';
import { tv } from 'tailwind-variants';

export interface DiscloseProps extends CollapsibleProps {
	label?: string;
}

const disclosure = tv({
	slots: {
		root: 'group w-full',
		content: '',
	},
});
</script>

<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core';
import { useForwardPropsEmits } from 'reka-ui';
import { computed } from 'vue';

import { useAppConfig } from '#app/config';
import { mergeUi } from '#layers/ui/utils/merge-ui';

const props = defineProps<DiscloseProps>();
const emits = defineEmits<CollapsibleEmits>();

const appConfig = useAppConfig();

const forwarded = useForwardPropsEmits(reactiveOmit(props, 'label'), emits);

const ui = computed(() => disclosure());
</script>

<template>
	<DCollapsible
		v-bind="forwarded"
		:ui="mergeUi(props.ui, {
			root: ui.root(),
			content: ui.content(),
		})"
	>
		<DButton
			class="flex w-full cursor-pointer items-center gap-1 px-0"
			variant="link"
			color="neutral"
			size="md"
			:icon="appConfig.ui.icons.chevronRight"
			:ui="{
				leadingIcon: forwarded.disabled ? 'hidden' : 'transition-transform duration-200 group-data-[state=open]:rotate-90',
			}"
		>
			<span class="whitespace-nowrap">{{ label }}</span>
			<DSeparator size="xs" class="ml-1" />
		</DButton>

		<template #content="slotProps">
			<slot v-bind="slotProps" />
		</template>
	</DCollapsible>
</template>
